import { ThunkAction } from 'redux-thunk';
import { State as LoginState } from '@telstra-connect/login';
import {closeCreditForm} from '../actions/close-credit-card-form';

export function closeCreditCardForm(data: boolean):
ThunkAction<void, LoginState.ISignInState, void> {
    return (dispatch) => {
        dispatch(closeCreditForm(data));
    }
}
